exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.zdytab .item[data-v-d142cbf0] {\n  flex: 0;\n  width: auto;\n  background: none!important;\n}\n.zdytab .item .btn[data-v-d142cbf0] {\n  height: 1.5rem;\n  width: 3.75rem;\n  line-height: 1.4rem;\n  background: white;\n  border: 0.05rem solid #cccccc;\n  color: #777;\n  box-sizing: content-box;\n  display: block;\n}\n.zdytab .item .type2[data-v-d142cbf0] {\n  width: 8.25rem;\n}\n.zdytab .active[data-v-d142cbf0] {\n  border-bottom: none!important;\n}\n.zdytab .active .btn[data-v-d142cbf0] {\n  color: white!important;\n  background: #00ab84;\n  border-color: #00ab84;\n}", ""]);

// exports
